<section>
  <h2>Event Locations</h2>
  <p-messages key="eventLocationMsg" [closable]="true"></p-messages>
  <p-table [value]="locations" [dataKey]="'AddressStagingID' || 'AddressID'" [paginator]="true" [alwaysShowPaginator]="false" [rows]="rows" [autoLayout]="true" responsiveLayout="scroll" styleClass="mb-3">
    <ng-template pTemplate="caption">
      <div class="p-2 fw-bold text-center">Location selection</div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th scope="col">Address</th>
        <th scope="col">City</th>
        <th scope="col">State</th>
        <th scope="col">Postal code</th>
        <th scope="col"><span class="visually-hidden">Delete</span></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td colspan="5">
          No locations found.
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
      <tr>
        <th scope="row"><button type="button" (click)="viewLocationDetails(rowData.AddressStagingID, rowData.AddressID, 'associated')" aria-label="View the location details" class="btn btn-link px-0">{{rowData.StreetAddress}}<ng-container *ngIf="!!rowData.Unit">, {{rowData.Unit}}</ng-container></button></th>
        <td>{{rowData.CityName}}</td>
        <td>{{rowData.StateName }}</td>
        <td>{{rowData.PostalCode}}</td>
        <td class="text-center"><button (click)="removeLocation(rowIndex)" type="button" class="btn btn-sm btn-danger" title="Remove location"><i class="fas fa-times" aria-hidden="true"></i><span class="visually-hidden">Remove location</span></button></td>
      </tr>
    </ng-template>
  </p-table>
  <div class="card my-3">
    <div class="card-body">
      <div class="card-title"><h3 class="h4 mb-3">Find an existing location</h3></div>
      <form [formGroup]="findLocationFormGroup" class="mb-3">
        <div class="row gy-2 gx-3 align-items-start mb-2">
          <div class="col-12 col-md-6">
            <label for="FindLocationStreetAddressID" class="form-label required-field">Street address:</label>
            <input id="FindLocationStreetAddressID" type="text" formControlName="FindLocationStreetAddressID" class="form-control form-control-sm mb-2 " aria-required="true" required />
            <div class="invalid-feedback">
              <div *ngIf="findLocationFormGroup.get('FindLocationStreetAddressID').hasError('maxlength')">The street address cannot exceed 80 characters.</div>
              <div *ngIf="findLocationFormGroup.get('FindLocationStreetAddressID').hasError('required')">
                Please enter a street address.
              </div>
            </div>
          </div>
          <div class="col-12 col-md-2">
            <label for="FindLocationUnitID" class="form-label">Unit:</label>
            <input id="FindLocationUnitID" type="text" formControlName="FindLocationUnitID" class="form-control form-control-sm mb-2" />
            <div class="invalid-feedback">
              The unit cannot exceed 80 characters.
            </div>
          </div>
        </div>
        <div class="row align-items-start">
          <div class="col-12 col-md-6 col-lg-3">
            <label for="FindLocationCityNameID" class="form-label">City:</label>
            <input id="FindLocationCityNameID" type="text" formControlName="FindLocationCityNameID" class="form-control form-control-sm mb-2" />
          </div>
          <div class="col-12 col-md-6 col-lg-3">
            <label for="FindLocationStateID" class="form-label">State:</label>
            <select class="form-select form-select-sm mb-2" id="FindLocationStateID" formControlName="FindLocationStateID">
              <option value="">Select state</option>
              <ng-container *ngIf="lookupService.usStates$ | async as usStates">
                <option *ngFor="let state of usStates" [value]="state.StateAbbreviation">{{state.StateName}}</option>
              </ng-container>
            </select>
          </div>
          <div class="col-12 col-md-6 col-lg-2">
            <label for="FindLocationPostalCodeID" class="form-label">Postal code:</label>
            <p-inputMask inputId="FindLocationPostalCodeID" mask="99999" formControlName="FindLocationPostalCodeID" styleClass="form-control form-control-sm mb-2" [autoClear]="true" (onBlur)="onMaskBlur('FindLocationPostalCodeID')"></p-inputMask>
            <div class="invalid-feedback">
              The postal code must contain at least contain 5 digits.
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-auto">
            <label for="FindLocationPostalCodeExtendedID" class="form-label">Postal code extended:</label>
            <p-inputMask inputId="FindLocationPostalCodeExtendedID" mask="9999" formControlName="FindLocationPostalCodeExtendedID" styleClass="form-control form-control-sm mb-2" [autoClear]="true" (onBlur)="onMaskBlur('FindLocationPostalCodeExtendedID')"></p-inputMask>
            <div class="invalid-feedback">
              The postal code extended must contain 4 digits.
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-auto align-self-end">
            <button [disabled]="findLocationFormGroup.invalid" type="button" (click)="onSearchLocation()" class="btn btn-sm btn-success mb-2"><i class="fas fa-search" aria-hidden="true"></i> Find</button>
          </div>
        </div>
      </form>
      <ng-container *ngIf="eventDataSvc.addressResults$ | async as addressResults; else loadingSearch">
        <p-table #dt [columns]="locationSearchResultTableCols" [value]="addressResults" selectionMode="multiple" [(selection)]="selectedAddresses" [paginator]="true" [alwaysShowPaginator]="false" [rows]="rows" [autoLayout]="true" responsiveLayout="scroll" styleClass="mb-3">
          <ng-template pTemplate="caption">
            <div class="p-2 fw-bold text-center">Find existing location result</div>
          </ng-template>
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th scope="col" [pSortableColumn]="col.field" *ngFor="let col of columns">
                {{col.header}}
                <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr [pSelectableRow]="rowData">
              <th scope="row"><button type="button" tabindex="0" aria-label="{{'View the address '+rowData.StreetAddressWithUnit+' details'}}" class="btn btn-link px-0" (click)="viewLocationDetails('', rowData.AddressID, 'find')">{{rowData.StreetAddressWithUnit}}</button></th>
              <td>{{ rowData.CityName }}</td>
              <td>{{ rowData.StateName }}</td>
              <td>{{ rowData.PostalCode}}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length">
                No location found.
              </td>
            </tr>
          </ng-template>
        </p-table>
        <button type="button" (click)="associateSelectedLocations()" [disabled]="selectedAddresses.length === 0" class="btn btn-success btn-sm me-2 my-3">Add selected location to event</button>
        <button type="button" (click)="onAddNewLocationClick()" class="btn btn-success btn-sm my-3">Add a new location</button>
      </ng-container>
      <ng-template #loadingSearch><p>Loading search results...</p></ng-template>
    </div>
  </div>
</section>
<p-sidebar [(visible)]="displaySidebar" (onHide)="onCloseSidebar()" position="right" [blockScroll]="true" styleClass="p-sidebar-lg" [showCloseIcon]="false">
  <ng-container *ngIf="openNewLocationForm">
    <ness-location-form [searchLocation]="searchAddress$ | async" [titleText]="addEditLocationTitleText" [isEventLocationForm]="true" [associationButtonLabel]="associationButtonLabel" (associateLocation)="onNewLocationAdded($event)" (closeForm)="onNewLocationClose()"></ness-location-form>
  </ng-container>
  <div class="row" *ngIf="openLocationViewDetail">
    <div class="col-md-12" *ngIf="eventDataSvc.locationAddress$ | async as address; else loadingDetails">
      <ness-location-detail *ngIf="showLocationDetailsView" #ld [addressDTO]="address" [hasEditPermission]="hasEditPermission" (editLocationLocationClicked)="showEditLocation($event)"></ness-location-detail>
      <ness-location-form *ngIf="showEditRMSLocationView" [titleText]="'Edit location'" [isEventLocationForm]="false" [isEditForm]="true" [locationFormData]="address" (closeForm)="onLocationDetailEditClose()" (locationSaved)="onLocationFormSaved($event)"></ness-location-form>
      <button *ngIf="showLocationDetailsView" type="button" (click)="onLocationDetailEditClose()" class="btn btn-active m-3">Close</button>
    </div>
    <ng-template #loadingDetails>
      <div class="m-3">Loading location details...</div>
    </ng-template>
  </div>
</p-sidebar>
